import { forwardRef } from 'react';
import { IconButton, IconButtonProps, Tooltip, TooltipProps } from '@mui/material';

interface TooltipIconButtonProps extends Omit<IconButtonProps, 'title'> {
  /** Tooltip text; also used as the aria-label. */
  title: string;
  tooltipProps?: Partial<Omit<TooltipProps, 'title' | 'children'>>;
}

const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
  function TooltipIconButton({ title, tooltipProps, disabled, children, ...rest }, ref) {
    const button = (
      <IconButton ref={ref} aria-label={title} disabled={disabled} {...rest}>
        {children}
      </IconButton>
    );
    return (
      <Tooltip title={title} {...tooltipProps}>
        {/* A disabled button fires no hover events, so it needs the span or its tooltip never shows. */}
        {disabled ? <span style={{ display: 'inline-flex' }}>{button}</span> : button}
      </Tooltip>
    );
  },
);

export default TooltipIconButton;
